import { Component, OnInit, Input, Optional, ViewChild, ElementRef } from '@angular/core';
import { FormControl, Validators, FormGroup, AbstractControl, ControlContainer, FormGroupDirective } from '@angular/forms';
import { ErrorMassageValidation } from '../../Shared/services/validationErrorMassage.service';
import { FileOptions } from '../../Shared/Models/FileOptions';
import { UtilityService } from '../../Shared/services/UtilityService';
import { ControlUtility } from '../../Shared/services/ControlUtility';


@Component({
  selector: 'BBSF-FileUplaod',
  templateUrl: './FileUplaod.component.html',
  styleUrls: ['./FileUplaod.component.scss']
})
export class FileUploadComponent implements OnInit {
  constructor(private ErrorHandler: ErrorMassageValidation, private controlUtility: ControlUtility, @Optional() private controlContainer: ControlContainer, public FileUplaodControlHost: FormGroupDirective) {
    FileUploadComponent.controlContainerstatic = this.controlContainer;
  }
  static controlContainerstatic = null;

  @ViewChild('fileInput', {static:true,read:null}) fileInput: ElementRef;

  isSubmitted: boolean;
  @Input() group: FormGroup;
  @Input() options: FileOptions;
  fileUploadFormControl: AbstractControl;
  ValidationMassage: string = ""

  ngOnInit() {
    UtilityService.isCreatedBefor = false

    if (this.options.FileMaxSizeInMB > 0) {
      this.ValidationMassage = this.ValidationMassage + ` Max File Size ${this.options.FileMaxSizeInMB} MB`
    }
    if (this.options.FileUploadAcceptsTypes != null && this.options.FileUploadAcceptsTypes.length > 0) {
      this.ValidationMassage = this.ValidationMassage + `<br /> Allowed extenstions (${this.options.FileUploadAcceptsTypes}) `
    }
    this.group.addControl(this.options.Name, new FormControl(''));
    this.fileUploadFormControl = this.group.controls[this.options.Name]; //  new FormControl('',validationRules);
    let validationRules = [];
    let validationRulesasync = [];


    if (this.options.IsRequired) {
      validationRules.push(Validators.required);
    }
    if (this.options.LabelKey != null && this.options.LabelKey != "")
      this.options.LabelValue = UtilityService.getResourceValue(this.options.LabelKey);

    this.fileUploadFormControl.setValidators(validationRules);
    this.fileUploadFormControl.setAsyncValidators(validationRulesasync);
    if (this.options.IsDisabled) {
      this.fileUploadFormControl.disable();
    }
  }

  ngAfterViewInit(): void {
    if (this.options.AttributeList != null) {
      var element = document.getElementById(this.options.Name);
      for (let index = 0; index < this.options.AttributeList.length; index++) {
        element.setAttribute(this.options.AttributeList[index].Key, this.options.AttributeList[index].value);
      }

    }

  }


  resetError = () => {
    UtilityService.RemoveGlobalError();
  }

  getErrorValidation(Errorsitem: any[]): string {
    return
  }

  onFileChange(event) {

    const file = event.target.files[0];
    const maxFileSize = this.options.FileMaxSizeInMB * 1000 * 1000;
    if (file) {
      const fileType = (file.type as string).split("/")[1];
      if (file.size > maxFileSize) {
        const formControl = this.fileUploadFormControl;
        formControl.setErrors({ "FileError": `File size must be less than ${this.options.FileMaxSizeInMB}M` });
        formControl.markAsTouched();
        return;

      }
    }

    let reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      let file = event.target.files[0];
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.group.get(this.options.Name).setValue({
          fileName: file.name,
          fileType: file.type,
          fileBase64: reader.result.toString().split(',')[1],
          fileSize: file.size,
        })
      };
    }
  }




}



